import React, { useEffect, useState } from 'react'
import { useWallet } from '@solana/wallet-adapter-react'

// next components

// components
import IconTab from 'components/Tab/IconTab'
import ActivitySection from 'components/pages/BrowseCollection/ActivitySection'
import AddSection from 'components/pages/BrowseCollection/AddSection'
// json
import TabList from 'assets/json/browse-collection/tab-list.json'
import TabNoAddList from 'assets/json/browse-collection/tab-list-no-add.json'

// resources

// styles
import styles from './index.module.scss'
import NFTSwiperSection from 'components/pages/BrowseCollection/NFTSwiperSection'
import CollectionTab from 'components/Tab/CollectionTab'

// apis

const TabSection = props => {
  const { hasloading, activeTab, nfts, collectionName, collectionId } = props

  const [artworkType, setArtworkType] = useState('all')
  const [tabList, setTabList] = useState<any[]>(TabList)
  const [tabNoAdd, setTabNoAdd] = useState<any[]>(TabNoAddList)
  const [filterKey, setFilterKey] = useState(null)
  const [activityCollections, setActivityCollections] = useState<any[]>([])

  useEffect(() => {
    let array: any[] = []
    TabList.map(item => {
      let object: any = item
      if (item.id === activeTab) {
        object.selected = true
      } else {
        object.selected = false
      }
      array.push(object)
    })
    setTabList(array)

    let array1: any[] = []
    TabNoAddList.map(item => {
      let object: any = item
      if (item.id === activeTab) {
        object.selected = true
      } else {
        object.selected = false
      }
      array1.push(object)
    })
    setTabNoAdd(array1)

    window.scrollTo(0, 0)
  }, [activeTab])

  return (
    <div className="w-full lg:min-h-[calc(100vh-140px)]">
      <div className="lg:sticky lg:top-[50px] lg:z-[100]">
        <CollectionTab
          activeTab={activeTab}
          artworkType={artworkType}
          setArtworkType={setArtworkType}
          filterKey={filterKey}
          setFilterKey={setFilterKey}
        />
      </div>

      <div className="w-full flex min-h-[calc(100vh-300px)]">
        {activeTab === 0 && (
          <div className="w-full flex flex-wrap z-10">
            <NFTSwiperSection
              hasloading={hasloading}
              nfts={nfts}
              collectionName={collectionName}
              showHideButton={false}
              artworkType={artworkType}
            />
          </div>
        )}

        {activeTab === 1 && (
          <div className="w-full flex flex-wrap z-10">
            <ActivitySection
              collectionId={collectionId}
              activityCollections={activityCollections}
              setActivityCollections={setActivityCollections}
              filterKey={filterKey}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default TabSection
